/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PaidPlanDto as FeatureSettingsPaidPlanDto } from '../models/feature/settings/paid-plan-dto';
import { RedirectUrlDto as FeatureSettingsRedirectUrlDto } from '../models/feature/settings/redirect-url-dto';
import { SubscriptionDetailsDto as FeatureSettingsSubscriptionDetailsDto } from '../models/feature/settings/subscription-details-dto';
import { getCustomerPortalUrl } from '../fn/subscription-settings/get-customer-portal-url';
import { GetCustomerPortalUrl$Params } from '../fn/subscription-settings/get-customer-portal-url';
import { getPaidPlans } from '../fn/subscription-settings/get-paid-plans';
import { GetPaidPlans$Params } from '../fn/subscription-settings/get-paid-plans';
import { getSubscriptionCheckoutUrl } from '../fn/subscription-settings/get-subscription-checkout-url';
import { GetSubscriptionCheckoutUrl$Params } from '../fn/subscription-settings/get-subscription-checkout-url';
import { getSubscriptionDetails } from '../fn/subscription-settings/get-subscription-details';
import { GetSubscriptionDetails$Params } from '../fn/subscription-settings/get-subscription-details';

@Injectable({ providedIn: 'root' })
export class SubscriptionSettingsClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `subscriptionSettingsGetSubscriptionDetails()` */
  static readonly SubscriptionSettingsGetSubscriptionDetailsPath = '/settings/subscription/details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionDetails$Response(context?: HttpContext): Observable<StrictHttpResponse<FeatureSettingsSubscriptionDetailsDto>> {
    const obs = getSubscriptionDetails(this.http, this.rootUrl, {} satisfies GetSubscriptionDetails$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionDetails(context?: HttpContext): Observable<FeatureSettingsSubscriptionDetailsDto> {
    const resp = this.getSubscriptionDetails$Response(context);
    return resp.pipe(
      map((r: StrictHttpResponse<FeatureSettingsSubscriptionDetailsDto>): FeatureSettingsSubscriptionDetailsDto => r.body)
    );
  }

  /** Path part for operation `subscriptionSettingsGetPaidPlans()` */
  static readonly SubscriptionSettingsGetPaidPlansPath = '/settings/subscription/paid-plans';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPaidPlans()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaidPlans$Response(context?: HttpContext): Observable<StrictHttpResponse<Array<FeatureSettingsPaidPlanDto>>> {
    const obs = getPaidPlans(this.http, this.rootUrl, {} satisfies GetPaidPlans$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPaidPlans$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaidPlans(context?: HttpContext): Observable<Array<FeatureSettingsPaidPlanDto>> {
    const resp = this.getPaidPlans$Response(context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<FeatureSettingsPaidPlanDto>>): Array<FeatureSettingsPaidPlanDto> => r.body)
    );
  }

  /** Path part for operation `subscriptionSettingsGetCustomerPortalUrl()` */
  static readonly SubscriptionSettingsGetCustomerPortalUrlPath = '/settings/subscription/customer-portal-url';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerPortalUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerPortalUrl$Response(params: GetCustomerPortalUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureSettingsRedirectUrlDto>> {
    const obs = getCustomerPortalUrl(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomerPortalUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerPortalUrl(params: GetCustomerPortalUrl$Params, context?: HttpContext): Observable<FeatureSettingsRedirectUrlDto> {
    const resp = this.getCustomerPortalUrl$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FeatureSettingsRedirectUrlDto>): FeatureSettingsRedirectUrlDto => r.body)
    );
  }

  /** Path part for operation `subscriptionSettingsGetSubscriptionCheckoutUrl()` */
  static readonly SubscriptionSettingsGetSubscriptionCheckoutUrlPath = '/settings/subscription/subscription-checkout-url';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionCheckoutUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionCheckoutUrl$Response(params: GetSubscriptionCheckoutUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureSettingsRedirectUrlDto>> {
    const obs = getSubscriptionCheckoutUrl(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionCheckoutUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionCheckoutUrl(params: GetSubscriptionCheckoutUrl$Params, context?: HttpContext): Observable<FeatureSettingsRedirectUrlDto> {
    const resp = this.getSubscriptionCheckoutUrl$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FeatureSettingsRedirectUrlDto>): FeatureSettingsRedirectUrlDto => r.body)
    );
  }

}
